"use strict";

exports.__esModule = true;
exports["default"] = ChevronLeft;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ChevronLeft(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.381 27.999a2.242 2.242 0 0 1 0 3.173 2.18 2.18 0 0 1-1.588.669c-.574 0-1.15-.221-1.588-.669L7.518 17.5a2.523 2.523 0 0 1-.471-.725 2.193 2.193 0 0 1-.181-.872c0-.299.06-.586.181-.854.109-.282.282-.523.471-.728L21.133.721a2.246 2.246 0 0 1 3.176 3.173L12.26 15.928l12.121 12.071z"
  }));
}